import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
//import 'bootstrap/dist/js/bootstrap.bundle.min'; // Import Bootstrap JavaScript
import { store } from './stores/store';
import { Provider } from 'react-redux';

// Polyfill for Object.hasOwn for older browsers (Safari < 15.4, etc.)
if (!Object.hasOwn) {
  Object.hasOwn = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

// Mount full app when app root exists
const appRoot = document.getElementById('root');
if (appRoot) {
  const root = ReactDOM.createRoot(appRoot);
  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
